module.exports = __webpack_public_path__ + "img/webcamera-icon.646fec10.svg";